import { environment } from '@env/environment'
import { AuthConfig } from 'angular-oauth2-oidc'

export const authConfig: AuthConfig = {
	clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040
	clientId: 'th.co.gofive.portal.dev',
	issuer: environment.issuer,
	postLogoutRedirectUri: environment.uri,
	redirectUri: environment.uri,
	requireHttps: false,
	scope: 'openid profile email client.portal.api offline_access ClientPortal.API Venio2.API GOFIVE.API',
	showDebugInformation: true, // Also requires enabling "Verbose" level in devtools\
	silentRefreshTimeout: 500,
	sessionChecksEnabled: true,
}
